/**
 * Created by osirvent on 07/06/2016.
 */
angular
    .module('annexaApp')
    .controller('CategoryController',['$scope', '$rootScope', 'AnnexaFormlyFactory', 'CommonAdminModals', 'HeaderService', '$state', '$filter', 'RestService', 'Language', 'CommonAdminService', 'AnnexaModalFactory', 'CommonService', 'dialogs', 'DialogsFactory', '$q', 'GlobalDataFactory', 'CacheFactory', 'HelperService', 'apiAdmin', function($scope, $rootScope, AnnexaFormlyFactory, CommonAdminModals, HeaderService, $state, $filter, RestService, Language, CommonAdminService, AnnexaModalFactory, CommonService, dialogs, DialogsFactory, $q, GlobalDataFactory, CacheFactory, HelperService, apiAdmin) {
        $scope.showLoadingdiv = false;

        HeaderService.onChangeState($scope, function (message) {
            if(message.state.name == 'annexa.admin.category') {
                $rootScope.subHeadButtons = [
                    new HeadButton('btn primary breadDivButton ml-sm-pt',undefined,'#admin-categories','fa fa-plus','global.commonAdmin.modal.category.titleNew',undefined,'newCategory'),
                    new HeadButton('btn primary breadDivButton ml-sm-pt',undefined,'#admin-categories','fa fa-download','global.literals.export',undefined,'exportCategories')
                ];
            }
        });

        HeaderService.changeState($state.current);

        //region New
        $scope.langColumn = Language.getActiveColumn();
        $scope.categories = CommonService.getNestableData(angular.copy(GlobalDataFactory.categories), 'category', 'orderView');

        $scope.toggle = function (scope) {
            scope.toggle();
        };

        $scope.treeOptions = {
            beforeDrop : function (e) {
                var deferred = $q.defer();
                DialogsFactory.confirm('global.commonAdmin.literals.category.move', 'global.commonAdmin.literals.category.confirmMove').then(function (dataAux) {
                    var sourceValue = e.source.nodeScope.$modelValue.category;
                    var sourceParentValue = null;
                    if( e.source.nodeScope.$modelValue.category.parent != null && e.source.nodeScope.$modelValue.category.parent != undefined) {
                        sourceParentValue = e.source.nodeScope.$modelValue.category.parent.id;
                    }
                    var destValue = e.dest.nodesScope.node ? e.dest.nodesScope.node.category: null;
                    if(destValue != null && destValue != undefined) {
                        sourceValue.parent = destValue;
                    }else {
                        sourceValue.parent = null;
                    }
                    if(e.dest != null){
                        sourceValue.orderView = e.dest.index+1;
                    }
                    $scope.saveCategory(sourceValue, deferred);
                }).catch(function (data) {
                    deferred.reject(false);
                });

                return deferred.promise;
            }
        };

        $scope.newCategory = function (node) {
            var modal =  angular.copy(CommonAdminModals.category);
            modal.annexaFormly.model = {};
            modal.annexaFormly.model.modal_body = {};
            modal.annexaFormly.options = {};
            modal.annexaFormly.fields[0].fieldGroup[1].templateOptions.labelProp = $scope.langColumn;
            modal.annexaFormly.fields[0].fieldGroup[1].templateOptions.options = GlobalDataFactory.categories; 
            if(node && !node.pageX) {
                modal.annexaFormly.fields[0].fieldGroup[1].defaultValue = node == undefined ? null : node;
            } else {
                modal.annexaFormly.fields[0].fieldGroup[1].defaultValue = undefined;
            }
            AnnexaFormlyFactory.showModal("modalCategory", modal, $scope.saveCategory, false);
        };

        $scope.openEditCategory = function (id, readonly) {
            RestService.findOne('Category', id)
                .then(function(data) {
                    var modal =  angular.copy(CommonAdminModals.categoryEdit);
                    modal.data = JSOG.decode(data.data);
                    modal.nameColumn = 'description';
                    modal.languageColumn = Language.getActiveColumn();
                    modal.category = $linq(GlobalDataFactory.categories).where("x => x.id !=" + modal.data.id + "&& (x.parent == null || x.parent.id !=" + modal.data.id+")").orderBy("x => x."+ $scope.langColumn,  linq.caseInsensitiveComparer).toArray(); 
                    modal.saveCategoryEdit = $scope.saveCategoryEdit;
                    modal.cancelCategoryEdit = $scope.cancelCategoryEdit;
                    AnnexaModalFactory.showModal('modalCategoryEdit', modal);
                });
        };

        $scope.saveCategoryEdit = function(val, prop) {
        	var model = this.data;

            if(prop == 'language1' || prop == 'language2' || prop == 'language3') {
                model = val;
            } else {
                model[prop] = val;
            }

            $scope.saveCategory(model, undefined, this);
        };

        $scope.saveCategory = function(category, deferred, mod) {
        	var model = {};
            var isNew = false;
            var modal = undefined;

            if(category.hasOwnProperty('annexaFormly')) {
                modal = this;
                if(category.annexaFormly.model.row1){
                	if(category.annexaFormly.model.row1.language1){
                		model.language1 = category.annexaFormly.model.row1.language1
                	}else{
                		 model.language1 = 'NotTranslated';
                	}
                	if(category.annexaFormly.model.row1.language2){
                		model.language2 = category.annexaFormly.model.row1.language2
                	}else{
                		 model.language2 = 'NotTranslated';
                	}
                	if(category.annexaFormly.model.row1.language3){
                		model.language3 = category.annexaFormly.model.row1.language3
                	}else{
                		 model.language3 = 'NotTranslated';
                	}
                	if (category.annexaFormly.model.row1.parent) {
                        if(category.annexaFormly.model.row1.parent instanceof Object) {
                            model.parent = category.annexaFormly.model.row1.parent;
                        } else {
                            model.parent = {id: category.annexaFormly.model.row1.parent};
                        }
                    } else {
                        model.parent = null;
                    }
                }else{
                	model.language1 = 'NotTranslated';
                    model.language2 = 'NotTranslated';
                    model.language3 = 'NotTranslated';
                    model.parent = null;
                }
                if (category.annexaFormly.model.row2) {
                	if (category.annexaFormly.model.row2.acronym) {
                        model.acronym = category.annexaFormly.model.row2.acronym;
                    } else {
                        model.acronym = null;
                    }
                	
                	if (category.annexaFormly.model.row2.code) {
                        model.code = category.annexaFormly.model.row2.code;
                    } else {
                        model.code = null;
                    }
                } else {
                	model.acronym = null;
                	model.code = null;
                }
                
                isNew = true;
            }else{
            	model = angular.copy(category);
            	modal = mod;
            }

            CommonAdminService.insertOrUpdateCategory(model).then(function(data) {
                if(isNew) {
                    modal.close();
                    GlobalDataFactory.categories.push(JSOG.decode(data));

                    $scope.categories = CommonService.getNestableData(GlobalDataFactory.categories, 'category', 'orderView');
                }else if(mod){
                	var indexModifiedCategory = $linq(GlobalDataFactory.categories).indexOf("x => x.id == " + data.id);

                    if(indexModifiedCategory != -1) {
                        GlobalDataFactory.categories[indexModifiedCategory].language1 = modal.data.language1;
                        GlobalDataFactory.categories[indexModifiedCategory].language2 = modal.data.language2;
                        GlobalDataFactory.categories[indexModifiedCategory].language3 = modal.data.language3;

                        $scope.categories = CommonService.getNestableData(GlobalDataFactory.categories, 'category', 'orderView');
                    }
                }
                if(GlobalDataFactory.categories){
                    GlobalDataFactory.categories.length = 0;
                }else{
                    GlobalDataFactory.categories = [];
                }
                if(CacheFactory.get('globalDataCache') && CacheFactory.get('globalDataCache').get('./api/general/findAll?object_type=Category')){
                    CacheFactory.get('globalDataCache').remove('./api/general/findAll?object_type=Category');
                }
                GlobalDataFactory.loadGlobalData().then(function (data) {
                    $scope.categories = CommonService.getNestableData(GlobalDataFactory.categories, 'category', 'orderView');
                }).catch(function (error) {});
                if (deferred) {
                    deferred.resolve(true);
                }
            }).catch(function(error) {
                console.log("ERROR");
                if (deferred) {
                    deferred.resolve(false);
                }
            });

        };

        $scope.deleteCategory = function(id) {
            if(id) {
                var dlg = dialogs.confirm(
                    $filter('translate')('global.commonAdmin.literals.category.delete'),
                    $filter('translate')('global.commonAdmin.literals.category.confirmDeleteMessage'),
                    {
                        animation: true,
                        backdrop: 'static',
                        keyboard: true,
                        size: ''
                    }
                );

                dlg.result.then(function (btn) {
                    CommonAdminService.deleteCategory(id).then(function (data) {
                        GlobalDataFactory.categories = JSOG.decode(data);
                        $scope.categories = CommonService.getNestableData(GlobalDataFactory.categories, 'category', 'orderView');
                        if(GlobalDataFactory.categories){
                            GlobalDataFactory.categories.length = 0;
                        }else{
                            GlobalDataFactory.categories = [];
                        }
                        if(CacheFactory.get('globalDataCache') && CacheFactory.get('globalDataCache').get('./api/general/findAll?object_type=Category')){
                            CacheFactory.get('globalDataCache').remove('./api/general/findAll?object_type=Category');
                        }
                        GlobalDataFactory.loadGlobalData().then(function (data) {
                            $scope.categories = CommonService.getNestableData(GlobalDataFactory.categories, 'category', 'orderView');
                        }).catch(function (error) {});
                    }).catch(function (error) {
                        var err = dialogs.error(
                            $filter('translate')('DIALOGS_ERROR_MSG'),
                            $filter('translate')(error.data.message),
                            {
                                animation: true,
                                backdrop: 'static',
                                keyboard: true,
                                size: ''
                            }
                        );
                    });
                }, function (btn) {
                });


            }
        };

        $scope.exportCategories = function(){
            $rootScope.showLoadingdivSignin = true;
            try {
                var cells = ['acronym',$scope.langColumn];
                var fileName = "category.xls";
                var xlsFile = HelperService.exportToExcel($scope.categories, 'nodes', cells, 'category', fileName, window, 'global.literals.categories');
                $rootScope.showLoadingdivSignin = false;
            } catch(e) {
                $rootScope.showLoadingdivSignin = false;
                console.log(e.message);
            }
        };
        //endregion
    }]);